import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Acm, AcmHasLayout } from 'app/models/loyalty-acm.model';
import { KoncentroValidators } from 'app/modules/UIKit/validators/koncentro-validators';
import { LoyaltyLayoutService } from 'app/services/loyalty/layout.service';
import { LoyaltyAcmLayoutService } from 'app/services/loyalty/loyalty-acm-layout.service';
import { LoyaltyAcmTypeService } from 'app/services/loyalty/loyalty-acm-type.service';
import { LoyaltyAcmService } from 'app/services/loyalty/loyalty-acm.service';
import { LoyaltyChannelService } from 'app/services/loyalty/loyalty-channel.service';
import { LoyaltyParamsService } from 'app/services/loyalty/params.service';
import { BreadCrumbModel } from 'app/views/campaign-3/models/campaign-3-breadcrumb.model';
import * as moment from 'moment';
import { ConfirmationService } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import { isUndefined } from 'util';



@Component({
  selector: 'app-form-acm-loyalty-3',
  templateUrl: './form-acm-loyalty-3.component.html',
  styleUrls: ['./form-acm-loyalty-3.component.css']
})
export class FormAcmLoyalty3Component implements OnInit {

  form: FormGroup;
  @Input() acmId: string;
  @Input() editMode: boolean;

  listChannel: { value: string, label: string }[];
  listAcmType: { value: string, label: string }[];
  listAcmOperatorType: { value: string, label: string }[];
  listAcmOperTrigger: { value: number, label: string, functional_code: string }[];
  listAcmResetTrigger: { value: number, label: string, functional_code: string }[];
  listDayOfWeek: { value: number, label: string }[];
  listAcmLayout: { value: number, label: string }[];

  listSelectedAcmLayouts: Array<any>;
  listSelectedAcmLayouts_modified: Array<any>;
  layoutsForm: Array<FormGroup>;
  currentLayout: any;
  newDataAvailable: boolean;
  infoDialogMessage: string;
  layoutToDelete: Array<any>;
  layoutToRecover: Array<any>;
  renderOk: boolean;
  acmEditMode: boolean;
  currentIndex: number;
  acmList: any;


  minStartDate : Date;
  


  dateStartIssue = false;
  dateEndIssue = false;
  dateStartMax = null;
  dateEndMin = null;

  show = {
    dialog: false,
    infoMessage: false,
    dialog_info: false,
    addButton: false
  }

  fields: any;
  fieldsLayout: any;
  public invalidSubmit: boolean;
  public validators = {
    integerNotNegative: KoncentroValidators.integerNotNegative,
    decimalNotNegative: KoncentroValidators.decimalNotNegative
  };

  defaultStartDate: Date;
  defaultEndDate: Date;
  defaultPtiStartDate: Date;
  defaultPtiEndDate: Date;

  constructor (
    private router: Router,
    private fb: FormBuilder,
    // private translate: TranslateService,
    private acmService: LoyaltyAcmService,
    private activatedRoute: ActivatedRoute,
    private paramService: LoyaltyParamsService,
    private layoutService: LoyaltyLayoutService,
    private channelService: LoyaltyChannelService,
    private acmTypeService: LoyaltyAcmTypeService,
    private acmLayoutService: LoyaltyAcmLayoutService,
    private datePipe: DatePipe,
    private confirmationService: ConfirmationService,
    private translateService: TranslateService
  ) { }

  get layouts(): FormArray {
    return this.form.get('layouts') as FormArray;
  }

  ngOnInit() {
    this.infoDialogMessage = '';
    this.currentLayout = null;
    this.layoutsForm = [];
    this.layoutToDelete = [];
    this.layoutToRecover = [];
    this.listSelectedAcmLayouts = [];

    this.listChannel = [{value: null, label: ''}];
    this.listAcmType = [{value: null, label: ''}];
    this.listAcmOperatorType = [{value: null, label: ''}];
    this.listAcmOperTrigger = [{value: null, label: '', functional_code: null}];
    this.listAcmResetTrigger = [{value: null, label: '', functional_code: null}];
    this.listDayOfWeek = [{value: null, label: ''}];
    this.listAcmLayout = [{value: null, label: ''}];

    this.acmId = this.activatedRoute.snapshot.params['acmId'];
    this.editMode = (typeof this.acmId !== 'undefined');

    let acm: Observable<Acm>;
    let LayoutForm: Observable<any>;


    this.initBreadCrumbs();

    this.acmService.getFields().subscribe(res => {
      this.fields = res;
    });

    this.acmService.getFieldsLayout().subscribe(res => {
      this.fieldsLayout = res;
    });

    if (!this.editMode) {
      acm = Observable.of(new Acm());
      LayoutForm = Observable.of(new AcmHasLayout());
    } else {
      acm = this.acmService.get(this.acmId);
      LayoutForm = this.acmLayoutService.list(this.acmId);
    }


      this.channelService.list().subscribe(
        res => {
          for ( const channel of res.data) {
            this.listChannel.push(
              {
                label: channel.channelDescription,
                value: channel.id
              }
            );
          }
        },
        error => console.error(error),
        () => sessionStorage.setItem('acmChannels', JSON.stringify(this.listChannel))
      );



      this.acmTypeService.list().subscribe(
        res => {
          for (const singleAcmType of res.data ) {
            this.listAcmType.push({
              label: singleAcmType.description,
              value: singleAcmType.id
            });
          }
        },
        error => console.error(error),
        () => sessionStorage.setItem('acmAcmType', JSON.stringify(this.listAcmType))
      );



      this.paramService.list(null , null , [{key: 'param_group', value: 'AcmOperatorType'}]).subscribe(
        res => {
          for (const singleParam of res.data ) {
            this.listAcmOperatorType.push({
              label: singleParam.description,
              value: singleParam.id
            });
          }
        },
        error => console.error(error),
        () => sessionStorage.setItem('acmAcmOperatorType', JSON.stringify(this.listAcmOperatorType))
      );



      this.paramService.list(null , null , [{key: 'param_group', value: 'AcmOperTrigger'}]).subscribe(
        res => {
        for (const singleParam of res.data ) {
          this.listAcmOperTrigger.push({
            label: singleParam.description,
            value: Number(singleParam.id),
            functional_code: singleParam.param_functional_code
          });
        }
        },
        error => console.error(error),
        () => sessionStorage.setItem('acmAcmOper', JSON.stringify(this.listAcmOperTrigger))
      );



      this.paramService.list(null , null , [{key: 'param_group', value: 'AcmResetTrigger'}]).subscribe(
        res => {
          for (const singleParam of res.data ) {
            this.listAcmResetTrigger.push({
              label: singleParam.description,
              value: Number(singleParam.id),
              functional_code: singleParam.param_functional_code
            });
          }
        },
        error => console.error(error),
        () => sessionStorage.setItem('acmAcmReset', JSON.stringify(this.listAcmResetTrigger))
      );

  

      this.paramService.list(null , null , [{key: 'param_group', value: 'DayOfWeek'}]).subscribe(
        res => {
          for (const singleParam of res.data ) {
            this.listDayOfWeek.push({
              label: singleParam.description,
              value: Number(singleParam.id)
            });
          }
        },
        error => console.error(error),
        () => sessionStorage.setItem('acmDaysOfWeek', JSON.stringify(this.listDayOfWeek))
      );



      this.layoutService.list().subscribe(
        res => {
          for (const singleLayout of res.data ) {
            this.listAcmLayout.push({
              label: singleLayout.description,
              value: Number(singleLayout.id)
            });
          }
          Observable.zip(acm, LayoutForm)
            .subscribe(([res, resAcmLayout]) => {

              if ( !isUndefined(resAcmLayout.data) ) {
                for (const layout of resAcmLayout.data) {
                  let tempLayout = this.listAcmLayout.find(obj => obj.value === layout['layout_id']);
                  // this.counterIndex++;
                  this.listSelectedAcmLayouts.push({
                    id: layout['id'],
                    acm_id: this.acmId ? this.acmId : null,
                    layout_id: tempLayout ? tempLayout.value : null,
                    layout_description: tempLayout ? tempLayout.label : '',
                    description_fe: layout['description_fe'],
                    format_string: layout['format_string'],
                    flg_state: layout['flg_state'],
                    operation: 'none'
                  });
                }
              }

              /*
              controllo se può essere mostrato il bottone add layout
              (va mostrato se non ci sono layout assegnati, oppure se quelli che esistono
              sono stati tutti cancellati logicamente)
              */

              this.checkAddButton();

              if (res.date_start) {
                this.defaultStartDate = new Date(res.date_start);
              }

              if (res.date_end) {
                this.defaultEndDate = new Date(res.date_end);
              }

              if (res.date_pti_start) {
                this.defaultPtiStartDate = new Date(res.date_pti_start);
              }

              if (res.date_pti_end) {
                this.defaultPtiEndDate = new Date(res.date_pti_end);
              }
    
              this.form = this.fb.group({
                channel_id: res.channel_id || '' ,
                acm_code: res.acm_code || '' ,
                acm_type_id: res.acm_type_id || '',
                description: res.description || '',
                short_descr: res.short_descr || '',
                date_start: res.date_start || '',
                date_end: res.date_end || '',
                flg_visible: !res.flg_visible || res.flg_visible === '1' ? false : true,

                host_code: res.host_code || '',
                oper_max_num_pid: res.oper_max_num_pid || '',
                max_num: res.max_num || '',
                oper_max_value_pid: res.oper_max_value_pid || '',

                max_value: res.max_value || '',
                oper_trigger_num_pid: res.oper_trigger_num_pid || '',
                oper_trigger_value_pid: res.oper_trigger_value_pid || '',
                def_num: res.def_num || '',

                def_value: res.def_value || '',
                flg_periodic_reset: res.flg_periodic_reset || false,
                period_reset_pid: res.period_reset_pid || '',
                value_period_pid: res.value_period_pid || '',
                trigger_cluster_id: res.trigger_cluster_id || '',

                date_pti_start: res.date_pti_start || null,
                date_pti_end: res.date_pti_end || null,

                // layouts: this.fb.array(this.layoutsForm)
                // layouts: [this.listSelectedAcmLayouts || null],
              });

              this.renderOk = true;
            });
            sessionStorage.setItem('acmAcmLayout', JSON.stringify(this.listAcmLayout));
        }
      );

  }

  checkActiveAcm() {
    if (!this.form.valid) {
      this.invalidSubmit = true;

      return;
    }
    this.invalidSubmit = false;
    let acmParams = [
      {key: "checkAcmCode", value: this.form.get('acm_code').value},
      {key: "flg_state", value: '0'}
    ];
    this.acmService.getAcmFromParams(acmParams).subscribe(res => {
      //create
      if (!this.editMode && res != null && res.length > 0) {
        this.confirmationService.confirm({
          message: this.translateService.instant('acm.checkAcmMessage'),
          acceptLabel: 'Ok',
          accept: () => this.save(),
          rejectVisible: true
        });
      }
      //edit
      else if (this.editMode && res.length > 1) {
        this.confirmationService.confirm({
          message: this.translateService.instant('acm.checkAcmMessage'),
          acceptLabel: 'Ok',
          accept: () => this.save(),
          rejectVisible: true
        });
      }
      else this.save();
    });
  }




  // KS-8028: converte in numero solo se il valore non è "vuoto"; riconosce sia '' (form mai valorizzata)
  // sia null/undefined (valore azzerato da codice, es. checkResetPeriod), evitando che +null diventi 0.
  private toNullableNumber(value: any): number | null {
    return (value === '' || value === null || value === undefined) ? null : +value;
  }

  save() {
    const acm = new Acm();
    acm.channel_id = this.form.get('channel_id').value;
    acm.acm_code = this.form.get('acm_code').value;
    acm.acm_type_id = this.form.get('acm_type_id').value;
    acm.description = this.form.get('description').value;
    acm.short_descr = this.form.get('short_descr').value;
    acm.date_start = moment(new Date(this.form.get('date_start').value)).format('YYYY-MM-DD');
    acm.date_end = moment(new Date(this.form.get('date_end').value)).format('YYYY-MM-DD');
    acm.flg_visible = this.form.get('flg_visible').value ? '0' : '1';
    acm.host_code = (this.form.get('host_code').value !== '') ? this.form.get('host_code').value : null;
    acm.oper_max_num_pid = this.toNullableNumber(this.form.get('oper_max_num_pid').value);
    acm.max_num = this.toNullableNumber(this.form.get('max_num').value);
    acm.oper_max_value_pid = this.toNullableNumber(this.form.get('oper_max_value_pid').value);
    acm.max_value = this.toNullableNumber(this.form.get('max_value').value);
    acm.oper_trigger_num_pid = this.toNullableNumber(this.form.get('oper_trigger_num_pid').value);
    acm.oper_trigger_value_pid = this.toNullableNumber(this.form.get('oper_trigger_value_pid').value);
    acm.def_num = this.toNullableNumber(this.form.get('def_num').value);
    acm.def_value = this.toNullableNumber(this.form.get('def_value').value);
    acm.flg_periodic_reset = (this.form.get('flg_periodic_reset').value) ? 1 : 0;
    acm.period_reset_pid = this.toNullableNumber(this.form.get('period_reset_pid').value);
    acm.value_period_pid = this.toNullableNumber(this.form.get('value_period_pid').value);
    acm.trigger_cluster_id = this.toNullableNumber(this.form.get('trigger_cluster_id').value);
    acm.date_pti_start = (this.form.get('date_pti_start').value !== null) ? moment(new Date(this.form.get('date_pti_start').value)).format('YYYY-MM-DD') : null;
    acm.date_pti_end = (this.form.get('date_pti_end').value !== null) ? moment(new Date(this.form.get('date_pti_end').value)).format('YYYY-MM-DD') : null;

    if (!this.editMode) {
      this.acmService.create(acm).subscribe(res => {
        this.acmId = res.id;
        this.saveLayout();
      },
      error => {
       console.log(error)
        
      });
    } else {

      acm.id = this.acmId;
      this.acmService.update(acm).subscribe(res => {
        this.saveLayout();
      },
      error => {
       console.log(error);
      });
    }

  }

  showAddOrEditDialog(currentIndex, data): void {
    this.currentLayout = data;
    if (currentIndex != null && data != null) {
      this.currentLayout['index'] = currentIndex;
    }
    this.openDialog();
  }

  // cancellazione logica di un layout
  deleteLayout(i: number) {
    let self = this;
    this.listSelectedAcmLayouts[i].flg_state = '1';
    if (this.listSelectedAcmLayouts[i].id != null) {
      let recoverIndex = this.layoutToRecover.findIndex(function(layout) {
        return layout.id === self.listSelectedAcmLayouts[i].id;
      });
      if (recoverIndex >= 0) {
        this.layoutToRecover.splice(recoverIndex, 1);
      }
      this.layoutToDelete.push(this.listSelectedAcmLayouts[i]);
    }

    this.checkAddButton();
    this.currentLayout = null;
    this.show.infoMessage = true;
  }

  // riabilitazione di un layout cancellato (cancellazione logica)
  recoverLayout(i) {

    let self = this;
    this.listSelectedAcmLayouts[i].flg_state = '0';
    this.listSelectedAcmLayouts[i].operation = 'edit';//il recover è gestito come un edit del layout

    if (this.listSelectedAcmLayouts[i].id != null) {

      let deleteIndex = this.layoutToDelete.findIndex(function(layout) {
        return layout.id === self.listSelectedAcmLayouts[i].id;
      });

      if (deleteIndex >= 0) {
        this.layoutToDelete.splice(deleteIndex, 1);
      }

      this.layoutToRecover.push(self.listSelectedAcmLayouts[i]);
    }

    this.checkAddButton();
    this.currentLayout = null;
    this.show.infoMessage = true;
  }

  checkAddButton() {
    let counterDeleted = 0;
    for (const layout of this.listSelectedAcmLayouts) {
      if (layout.flg_state === '1') {
        counterDeleted++;
      }
    }

    if (counterDeleted === this.listSelectedAcmLayouts.length) {
      this.show.addButton = true;
    } else {
      this.show.addButton = false;
    }
  }

  saveLayout() {

    const requests = [];

    // caso delete layout esistente
    for (let i = 0; i < this.layoutToDelete.length; i++) {
      requests.push(this.acmLayoutService.remove(this.acmId, this.layoutToDelete[i].layout_id));
    }

    for (let i = 0; i < this.listSelectedAcmLayouts.length; i++) {
      // caso edit di un layout esistente (ancora non previsto, intanto c'è la predisposizione)
      if(this.listSelectedAcmLayouts[i].id > 0 && this.listSelectedAcmLayouts[i].operation == "edit"){
        requests.push(this.acmLayoutService.update(this.listSelectedAcmLayouts[i]));
      }


      // caso add nuovo layout
      if (this.listSelectedAcmLayouts[i].operation === 'add') {
        requests.push(this.acmLayoutService.create(this.listSelectedAcmLayouts[i]));
      }
    }
    if (this.listSelectedAcmLayouts.length > 0) {

      Observable.zip(...requests).subscribe((resCreateDetails) => {
        this.router.navigate(['/loyalty3/acm/']);
      });
    } else {
      this.router.navigate(['/loyalty3/acm/']);
    }

  }

  searchLabel (id, value, nameArray) {
    let bool = false;
    for (const item of nameArray ) {
      if ( item.value === id) {
        // console.log('code:', item.functional_code);
        // console.log('value:', value);
        if (item.functional_code === value) {
          bool = true;
        }
      }
    }
    return bool;
  }

  /*
  remove(data): void {
    let index = this.listSelectedAcmLayouts.findIndex(obj => obj["index"] == data["index"]);
    this.listSelectedAcmLayouts.splice(index,1);
    //this.fireNewData();
    this.show.infoMessage = true;
  }
  */

  layoutAdded(data): void {

    /*
    Nonostante si utilizza un array, è concesso di inserire un solo layout
    Ho utilizzato array per predispormi nel caso un giorno si prevedano N layout.
    */

    let tempLayout = this.listAcmLayout.find(obj => obj.value === data['layout_id']);

    this.listSelectedAcmLayouts.push({
      id: null,
      acm_id: this.acmId ? this.acmId : null,
      layout_id: tempLayout ? tempLayout.value : null,
      layout_description: tempLayout ? tempLayout.label : '',
      description_fe: data['description_fe'],
      format_string: data['format_string'],
      flg_state: '0',
      operation: 'add'
    });

    this.closeDialog();
    this.show.infoMessage = true;
    this.show.addButton = false;

  }

  // edit di un layout (ancora non previsto, ma predisposto)
  layoutUpdated(data): void {
     /*
    Caso in cui era un record ancora non esistente, ma aggiunto col bottone add.
    In questo caso non dovrò chiamare il servizio di edit, ma il servizio di add
    */

   if (data.id == null) {
    data['operation'] = 'add';
  } else {
  /*
  Caso in cui si modifica di un record esistente in precedenza,
  perciò dovrò chiamare il servizio di edit
  */
    data['operation'] = 'edit';
  }

  this.listSelectedAcmLayouts[this.currentIndex] = data;
  this.show.infoMessage = true;
  // this.fireNewData();
  this.closeDialog();

  }

  openDialog() {
    this.show.dialog = true;
  }

  closeDialog() {
    this.show.dialog = false;
    this.currentIndex = null;
  }

  checkResetPeriod(event) {
    if (event.value === 91 || event.value === 93) {  // 93 corrisponde a "Mensilmente"
      this.form.controls.value_period_pid.setValue(null);
    }
  }

  editLayout(i) {
    // azioni per modifica layout acm
    this.currentLayout = this.listSelectedAcmLayouts[i];
    this.currentIndex = i;
    this.acmEditMode = true;
    this.openDialog();
  }


//gestione Bredcrumb
 
breadcrumbClicked(breadbrumb: BreadCrumbModel) {
  console.log(breadbrumb);
  if (breadbrumb.routerLink) {
    // Correzione qui
    this.router.navigate([breadbrumb.routerLink]);
  } else {
    console.log("nessuna route implementata");
  }
}


    breadcrumbs: Array<BreadCrumbModel> = [];
    initBreadCrumbs() {
      let bc1 = new BreadCrumbModel();
      bc1.code = "acm1";
      bc1.description = "Accumulatori";
      bc1.routerLink= "/loyalty3/acm";
      this.breadcrumbs.push(bc1);

      let bc2 = new BreadCrumbModel();
      bc2.code = "acm2";
      bc2.description = "Create/Edit ACM";
      bc2.routerLink= "/loyalty3/acm/form"
      this.breadcrumbs.push(bc2);
    }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty-3/form-acm-loyalty-3/form-acm-loyalty-3.component.ts